module.exports = __webpack_public_path__ + "img/farzana-christopher-67.d6dac75d.jpg";